<template>
  <div class="field has-text-centered">
    <div class="control">
      <div class="control has-icons-left has-icons-right">
        <input
          title="Search bar"
          id="searchBar"
          class="input is-medium"
          v-model="queryString"
          v-bind:placeholder="placeholder"
          v-bind:searchRoute="searchRoute"
        >
        <span class="icon is-left">
          <font-awesome-icon icon="search"></font-awesome-icon>
        </span>
        <span class="icon is-right">
          <font-awesome-icon icon="check"></font-awesome-icon>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: [
      'searchRoute',
      'placeholder'
    ],
    data () {
      return {
        queryString: ''
      }
    },
    watch: {
      queryString () {
        /* Set route */
        const route = {
          name: this.searchRoute
        }

        /* Add search query */
        if (this.queryString !== '') {
          route.query = {
            q: this.queryString
          }
        }

        /* Push route */
        this.$router.push(route)
      },
      '$route.query.q': {
        immediate: true,
        handler (value) {
          this.queryString = value
        }
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/General/SearchBar.vue